import { render, staticRenderFns } from "./TableHeaderSorter.vue?vue&type=template&id=6c87c43e&"
import script from "./TableHeaderSorter.vue?vue&type=script&lang=ts&"
export * from "./TableHeaderSorter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports